// Data for 2026 calendar including photos, blessings and poems
// 12 months of data for 2026

export interface CalendarDay {
  date: string; // YYYY-MM-DD
  photo: string; // URL or path to photo
  blessing: string; //祝福 message
  poem?: string; // Background poem for the day
  dailyMessage?: string; // Daily message for the day
  isHoliday?: boolean; // Flag if this day is a special holiday
  holidayName?: string; // Name of the holiday if applicable
}

// Array of daily messages
const dailyMessages = [
  "愿你的每一天都充满阳光与温暖，心境如诗如画。",
  "生活如诗，岁月如歌，愿你拥有美好的一天。",
  "每一个清晨都是新的开始，愿你心情愉悦。",
  "愿你的心情如春日暖阳，温暖而明亮。",
  "在忙碌的生活中，别忘了欣赏身边的美好。",
  "愿你今天的心情如花儿般绽放。",
  "每一天都是生命中独特的一天，珍惜当下。",
  "愿你的笑容如阳光般灿烂。",
  "愿你的心情如微风般轻松自在。",
  "愿你今天的每一步都走得踏实而快乐。",
  "愿你被温柔以待，被幸福围绕。",
  "愿你所有的努力都能开花结果。",
  "愿你拥有最美好的心情。",
  "愿你所求皆如愿，所行化坦途。",
  "愿你快乐多一点，烦恼少一点。",
  "愿你与快乐撞个满怀。",
  "愿你此生尽兴，赤诚善良。",
  "愿历尽千帆，归来仍是少年。",
  "愿你的生活充满诗意和远方。",
  "愿你拥有四海八荒的热闹。",
  "愿你被这个世界温柔以待。",
  "愿你有软肋也有盔甲。",
  "愿你勇敢且善良，乐观并豁达。",
  "愿你眼中有美，心中有爱。",
  "愿你保持热爱，奔赴山海。",
  "愿你所有的努力都能开花结果。",
  "愿你所有的美好如期而至。",
  "愿你被爱围绕，被幸福拥抱。",
  "愿你的每一天都被温柔对待。",
  "行到水穷处，坐看云起时。",
  "愿你以梦为马，不负韶华。",
  "愿你前程似锦，归来仍是少年。",
  "愿如向日葵般，永远面朝阳光。",
  "愿你的生活五彩斑斓。",
  "愿你的心境澄澈如水。",
  "愿你步履从容，心境悠然。",
  "岁月静好，愿你安好。",
  "愿你内心丰盈，自在如风。",
  "愿你拥有简单而快乐的生活。",
  "愿你心中有光，脚下有路。"
];

// Array of poems for background elements
const poems = [
  "春风十里不如你",
  "山有木兮木有枝",
  "关关雎鸠，在河之洲",
  "青青子衿，悠悠我心",
  "蒹葭苍苍，白露为霜",
  "桃之夭夭，灼灼其华",
  "死生契阔，与子成说",
  "投我以木桃，报之以琼瑶",
  "昔我往矣，杨柳依依",
  "采薇采薇，薇亦作止",
  "知我者谓我心忧",
  "硕鼠硕鼠，无食我黍",
  "七月流火，九月授衣",
  "彼采萧兮，一日不见",
  "庭有枇杷树，吾妻死之年所手植也",
  "落霞与孤鹜齐飞，秋水共长天一色",
  "海内存知己，天涯若比邻",
  "劝君更尽一杯酒，西出阳关无故人",
  "春眠不觉晓，处处闻啼鸟",
  "红豆生南国，春来发几枝"
];

// Array of blessing messages with seasonal and Chinese elements (no longevity-focused)
const winterBlessings = [
  "愿你三冬暖，春不寒 --来自豆同学",
  "愿你的冬天温暖如春 --来自豆同学",
  "雪花纷飞的日子，愿你心中有火 --来自豆同学",
  "冬日漫长，愿你内心有光 --来自豆同学",
  "寒来暑往，愿你始终向阳 --来自豆同学",
  "冰天雪地里，愿你温暖如初 --来自豆同学",
  "冬日虽寒，愿你心有暖阳 --来自豆同学",
  "岁月清寒，愿你安然无恙 --来自豆同学"
];

const springBlessings = [
  "春风十里不如你 --来自豆同学",
  "愿你如春花般绚烂 --来自豆同学",
  "春暖花开，愿你笑靥如花 --来自豆同学",
  "新绿满枝，愿你生机勃勃 --来自豆同学",
  "春意盎然，愿你心情如春 --来自豆同学",
  "万物复苏，愿你元气满满 --来自豆同学",
  "春天来了，愿你心中有花海 --来自豆同学",
  "春光正好，愿你未来可期 --来自豆同学"
];

const summerBlessings = [
  "夏日炎炎，愿你清凉如风 --来自豆同学",
  "愿你如夏花之绚烂 --来自豆同学",
  "阳光灿烂的日子，愿你笑容灿烂 --来自豆同学",
  "夏风拂面，愿你自在如风 --来自豆同学",
  "绿荫如盖，愿你心境清凉 --来自豆同学",
  "愿你在这个夏天闪闪发光 --来自豆同学",
  "夏日悠长，愿你快乐无边 --来自豆同学",
  "蝉鸣声声，愿你心情愉悦 --来自豆同学"
];

const autumnBlessings = [
  "秋高气爽，愿你心情舒畅 --来自豆同学",
  "金桂飘香，愿你生活甜美 --来自豆同学",
  "秋叶飞舞，愿你随遇而安 --来自豆同学",
  "秋水如镜，愿你心境澄澈 --来自豆同学",
  "稻香满园，愿你收获满满 --来自豆同学",
  "秋风送爽，愿你神清气爽 --来自豆同学",
  "落叶知秋，愿你懂得珍惜 --来自豆同学",
  "秋色宜人，愿你生活如画 --来自豆同学"
];

const allSeasonBlessings = [
  "愿你每一天都充满阳光 --来自豆同学",
  "愿你的笑容比阳光更灿烂 --来自豆同学",
  "愿你的生活充满甜蜜 --来自豆同学",
  "愿你被温柔以待 --来自豆同学",
  "愿你的梦想一一实现 --来自豆同学",
  "愿你心中有爱，眼中有光 --来自豆同学",
  "愿你的每一天都是新的开始 --来自豆同学",
  "愿你的努力得到回报 --来自豆同学",
  "愿你的未来如花般绚烂 --来自豆同学",
  "愿你平安喜乐，万事顺意 --来自豆同学",
  "愿你的世界永远温暖如春 --来自豆同学",
  "愿你被这世界温柔相待 --来自豆同学",
  "愿你的每一天都值得纪念 --来自豆同学",
  "愿你拥有最美好的心情 --来自豆同学",
  "愿你所求皆如愿，所行化坦途 --来自豆同学",
  "愿你快乐多一点，烦恼少一点 --来自豆同学",
  "愿你与快乐撞个满怀 --来自豆同学",
  "愿你此生尽兴，赤诚善良 --来自豆同学",
  "愿历尽千帆，归来仍是少年 --来自豆同学",
  "愿你的生活充满诗意和远方 --来自豆同学",
  "愿你拥有四海八荒的热闹 --来自豆同学",
  "愿你被这个世界温柔以待 --来自豆同学",
  "愿你有软肋也有盔甲 --来自豆同学",
  "愿你勇敢且善良，乐观并豁达 --来自豆同学",
  "愿你眼中有美，心中有爱 --来自豆同学",
  "愿你保持热爱，奔赴山海 --来自豆同学",
  "愿你所有努力都能开花结果 --来自豆同学",
  "愿你所有的美好如期而至 --来自豆同学",
  "愿你被爱围绕，被幸福拥抱 --来自豆同学",
  "愿你的每一天都被温柔对待 --来自豆同学",
  "行到水穷处，坐看云起时 --来自豆同学",
  "愿你以梦为马，不负韶华 --来自豆同学",
  "愿你前程似锦，归来仍是少年 --来自豆同学",
  "愿你如向日葵般，永远面朝阳光 --来自豆同学",
  "愿你的生活五彩斑斓 --来自豆同学",
  "愿你的心境澄澈如水 --来自豆同学",
  "愿你步履从容，心境悠然 --来自豆同学",
  "岁月静好，愿你安好 --来自豆同学"
];

// Define holidays with special messages
const holidays: Record<string, { name: string, message: string }> = {
  '2026-01-01': { name: '新年', message: '新年快乐！愿新的一年里，每一天都充满希望和惊喜 --来自豆同学' },
  '2026-02-14': { name: '情人节', message: '情人节快乐！愿有情人终成眷属 --来自豆同学' },
  '2026-03-12': { name: '植树节', message: '植树节快乐！愿绿色遍布大地，环境更加美好 --来自豆同学' },
  '2026-04-01': { name: '愚人节', message: '愚人节快乐！愿你的生活充满欢声笑语 --来自豆同学' },
  '2026-04-04': { name: '寒食节', message: '寒食节快乐！缅怀先人，珍惜当下 --来自豆同学' },
  '2026-05-01': { name: '劳动节', message: '劳动节快乐！致敬每一个努力奋斗的你 --来自豆同学' },
  '2026-05-10': { name: '母亲节', message: '母亲节快乐！感谢母亲的无私奉献 --来自豆同学' },
  '2026-05-21': { name: '生日/小满', message: '生日快乐！同时今天也是小满节气，小得盈满，恰到好处 --来自豆同学' },
  '2026-06-01': { name: '儿童节', message: '儿童节快乐！愿你永远保持童心，快乐无忧 --来自豆同学' },
  '2026-06-21': { name: '夏至/父亲节', message: '夏至快乐！同时也是父亲节，向父亲表达感恩之情 --来自豆同学' },
  '2026-07-01': { name: '建党节', message: '建党节快乐！铭记历史，展望未来 --来自豆同学' },
  '2026-08-23': { name: '七夕节/处暑', message: '七夕节快乐！愿有情人都能白头偕老，同时今天也是处暑节气 --来自豆同学' },
  '2026-09-07': { name: '白露', message: '白露节气！露凝而白，秋高气爽 --来自豆同学' },
  '2026-09-22': { name: '秋分', message: '秋分快乐！昼夜平分，愿你内心平衡，同时也是秋分节气 --来自豆同学' },
  '2026-10-01': { name: '国庆节', message: '国庆节快乐！愿祖国繁荣昌盛 --来自豆同学' },
  '2026-10-06': { name: '中秋节', message: '中秋节快乐！月圆人团圆，愿你团团圆圆 --来自豆同学' },
  '2026-10-08': { name: '寒露', message: '寒露节气！露气寒凝，秋意深浓 --来自豆同学' },
  '2026-10-23': { name: '霜降', message: '霜降节气！霜降碧天静，秋事促西风 --来自豆同学' },
  '2026-11-07': { name: '立冬', message: '立冬节气！冬季的开始，收藏万物 --来自豆同学' },
  '2026-11-22': { name: '小雪', message: '小雪节气！雪花纷飞，冬日静美 --来自豆同学' },
  '2026-12-07': { name: '大雪', message: '大雪节气！雪量增大，冬日深沉 --来自豆同学' },
  '2026-12-21': { name: '冬至', message: '冬至快乐！最长的夜晚，愿你内心温暖，同时也是冬至节气 --来自豆同学' },
  '2026-12-25': { name: '圣诞节', message: '圣诞节快乐！愿圣诞老人带给你好运 --来自豆同学' }
};

// Generate calendar data for 2026
export const generateCalendarData = (): CalendarDay[] => {
  const calendarData: CalendarDay[] = [];
  
  // Days in each month for 2026 (not a leap year)
  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  
  for (let month = 0; month < 12; month++) {
    for (let day = 1; day <= daysInMonth[month]; day++) {
      const date = `2026-${(month + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      
      let blessing = '';
      let isHoliday = false;
      let holidayName = '';
      
      // Check if this date is a special holiday
      if (holidays[date]) {
        const holidayInfo = holidays[date];
        blessing = holidayInfo.message;
        isHoliday = true;
        holidayName = holidayInfo.name;
      } else {
        // Choose blessings based on season
        let seasonalBlessings = allSeasonBlessings;
        
        if (month >= 11 || month <= 1) { // Dec, Jan, Feb (winter)
          seasonalBlessings = [...winterBlessings, ...allSeasonBlessings];
        } else if (month >= 2 && month <= 4) { // Mar, Apr, May (spring)
          seasonalBlessings = [...springBlessings, ...allSeasonBlessings];
        } else if (month >= 5 && month <= 7) { // Jun, Jul, Aug (summer)
          seasonalBlessings = [...summerBlessings, ...allSeasonBlessings];
        } else if (month >= 8 && month <= 10) { // Sep, Oct, Nov (autumn)
          seasonalBlessings = [...autumnBlessings, ...allSeasonBlessings];
        }
        
        const dayOfYear = (new Date(date)).getTime() / (1000 * 60 * 60 * 24) - (new Date('2026-01-01')).getTime() / (1000 * 60 * 60 * 24);
        const blessingIndex = Math.floor(dayOfYear) % seasonalBlessings.length;
        blessing = seasonalBlessings[blessingIndex];
      }
      
      // Select a photo based on season
      const photo = getPhotoForDate(date);
      
      // Select a poem for the background
      const poemIndex = Math.floor(Math.random() * poems.length);
      const poem = poems[poemIndex];
      
      // Select a daily message for the background
      const messageIndex = Math.floor(Math.random() * dailyMessages.length);
      const dailyMessage = dailyMessages[messageIndex];

      calendarData.push({
        date,
        photo,
        blessing,
        poem,
        dailyMessage,
        isHoliday,
        holidayName
      });
    }
  }
  
  return calendarData;
};

// Function to get photo based on season
const getPhotoForDate = (date: string): string => {
  const month = parseInt(date.split('-')[1]);
  const day = parseInt(date.split('-')[2]);

  // Create a unique seed for each day to ensure different photos daily
  const dateSeed = `${date}-${month}-${day}`;

  // Seasonal photo URLs or placeholders using Picsum for reliability
  if (month === 1 || month === 2 || month === 11 || month === 12) {
    // Winter months - snowy landscapes, winter scenes
    return `https://picsum.photos/seed/winter-${dateSeed}/1200/800`;
  } else if (month >= 3 && month <= 5) {
    // Spring months - green landscapes, blooming scenes
    return `https://picsum.photos/seed/spring-${dateSeed}/1200/800`;
  } else if (month >= 6 && month <= 8) {
    // Summer months - bright, colorful landscapes
    return `https://picsum.photos/seed/summer-${dateSeed}/1200/800`;
  } else if (month >= 9 && month <= 10) {
    // Fall months - autumn colors, golden tones
    return `https://picsum.photos/seed/autumn-${dateSeed}/1200/800`;
  } else {
    // Default to colorful
    return `https://picsum.photos/seed/nature-${dateSeed}/1200/800`;
  }
};

export const calendarData = generateCalendarData();